import { render, staticRenderFns } from "./LeavesEdit.vue?vue&type=template&id=b295e4a2&"
import script from "./LeavesEdit.vue?vue&type=script&lang=js&"
export * from "./LeavesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports